import Activate from './activate';

export default Activate;
